module.exports = __webpack_public_path__ + "img/cog.da83ae1f.svg";